import 'jquery-validation';

jQuery(document).ready(function($) {
    $('.newsletterBlock__form').validate({
        errorElement: "span",
        // any other default options and/or rules
        errorPlacement: function(error, element) {
            error.appendTo( element.parents('.newsletterBlock__form') );
        }
    });
})